import React from 'react'
import { Confirm, LinkWithIcon } from '../../application'
import getText from '../strings'
import styled from 'react-emotion'

const Wrapper = styled('div')`
  display: flex;
  margin-top: 5px;
  margin-bottom: 20px;
  justify-content: flex-end;
`

export default ({ bookingNumber, removeBooking }) => (
  <Wrapper>
    <Confirm
      question={getText('remove', 'confirm')}
      onResult={res => res && removeBooking(bookingNumber)}
      Opener={() =>
        <LinkWithIcon text={getText('buttons', 'removeBooking')} icon="times" />
      } />
  </Wrapper>
)